/* src/modules/feedback/FeedbackModule.js */
import React, { useState } from 'react';
import { ChatAltIcon, LockClosedIcon } from '../../components/icons/Icons';
import HRDiscussionBoard from './HRDiscussionBoard';
import FounderChannel from './FounderChannel';

// --- CONSTANTS ---
const FOUNDER_EMAILS = [
    'amit@linceducation.com', 
    'abhinav@linceducation.com', 
    'pranav@linceducation.com'
];

export default function FeedbackModule({ userProfile, appId }) {
    const [activeTab, setActiveTab] = useState('discussion'); // 'discussion' | 'founders'
    
const isHRAdmin = userProfile.role === 'HR' || 
                      userProfile.role === 'Admin' || 
                      userProfile.department === 'HR';
    const isFounder = FOUNDER_EMAILS.includes(userProfile.email) || userProfile.role === 'Admin'; 

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-center bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                <div>
                    <h2 className="text-2xl font-bold text-[#213368]">Feedback & Discussions</h2>
                    <p className="text-sm text-gray-500">Engage with HR or share feedback directly with Founders.</p>
                </div>
                <div className="flex space-x-2 mt-4 md:mt-0 bg-gray-100 p-1 rounded-lg">
                    <TabButton 
                        active={activeTab === 'discussion'} 
                        onClick={() => setActiveTab('discussion')} 
                        label="HR Discussion Board" 
                        icon={ChatAltIcon} 
                    />
                    <TabButton 
                        active={activeTab === 'founders'} 
                        onClick={() => setActiveTab('founders')} 
                        // ✅ Renamed Tab as requested
                        label="A.A.P. Se Baat (Founder Connect)" 
                        icon={LockClosedIcon} 
                    />
                </div>
            </div>

            {/* Content Area */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 min-h-[500px]">
                {activeTab === 'discussion' && (
                    <HRDiscussionBoard userProfile={userProfile} appId={appId} isHRAdmin={isHRAdmin} />
                )}
                {activeTab === 'founders' && (
                    <FounderChannel userProfile={userProfile} appId={appId} isFounder={isFounder} />
                )}
            </div>
        </div>
    );
}

function TabButton({ active, onClick, label, icon: Icon }) {
    return (
        <button
            onClick={onClick}
            className={`flex items-center px-4 py-2 rounded-md text-sm font-bold transition-all ${
                active ? 'bg-white text-[#213368] shadow-sm' : 'text-gray-500 hover:text-gray-700'
            }`}
        >
            <Icon className="h-4 w-4 mr-2" />
            {label}
        </button>
    );
}